import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { useCopies } from "shared/hooks/useCopies";
import { ApiProgramParticipantToManage } from "shared/types/ApiProgramParticipantToManage";
import { successToast } from "shared/utils/toastNotification";
import { usePostApiData } from "shared/datalayer";
import { ApiProgramParticipantAddMeetingRepTagRequest, ApiProgramParticipantRemoveMeetingRepTagRequest } from "./types";

export function useAddMeetingRepTag() {
  const copies = useCopies();
  return usePostApiData<ApiProgramParticipantToManage, ApiProgramParticipantAddMeetingRepTagRequest>(
    MyExpApi.ADD_MEETING_REP_TAG,
    {
      onSuccess: () => {
        successToast(copies.get("org.admin.assign.meeting.rep.success"));
      }
    }
  );
}

export function useRemoveMeetingRepTag() {
  const copies = useCopies();
  return usePostApiData<ApiProgramParticipantToManage, ApiProgramParticipantRemoveMeetingRepTagRequest>(
    MyExpApi.REMOVE_MEETING_REP_TAG,
    {
      onSuccess: () => {
        successToast(copies.get("org.admin.remove.meeting.rep.success"));
      }
    }
  );
}
